import { Button, Box } from "@mui/material";
import { Visibility as ViewIcon } from '@mui/icons-material';
import { useState } from "react";
import TranslationViewer from "./TranslationViewer";
import FullScreenDialog from "./FullScreenDialog";

const TranslationViewerDialog = ({ text, textWordObjects, dictionary, phrasalVerbs, phrasesDictionary }) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Button 
                variant="outlined" 
                size="small"
                startIcon={<ViewIcon />}
                onClick={() => setOpen(true)}
                disabled={!text || !textWordObjects}
            >
                View Translation
            </Button>

            <FullScreenDialog open={open} onClose={() => setOpen(false)} title="Translation Viewer">
                <Box sx={{ p: 2 }}>
                    {open && (
                        <TranslationViewer 
                            text={text?.text}
                            wordObjectsArray={textWordObjects}
                            dictionary={dictionary}
                            phrasalVerbs={phrasalVerbs}
                            phrasesDictionary={phrasesDictionary}
                        />
                    )}
                </Box>
            </FullScreenDialog>
        </>
    );
};

export default TranslationViewerDialog